import { render, staticRenderFns } from "./LastImageInfo.vue?vue&type=template&id=2f31c585&scoped=true&"
import script from "./LastImageInfo.vue?vue&type=script&lang=ts&"
export * from "./LastImageInfo.vue?vue&type=script&lang=ts&"
import style0 from "./LastImageInfo.vue?vue&type=style&index=0&id=2f31c585&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f31c585",
  null
  
)

export default component.exports